import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteCar, selectDelSuccessState, resetDeleteState } from "../../../redux/car/car-del-slice";

const DeleteCar = ({ car, closeButtomSheetHandler }) => {
  const dispatch = useDispatch();
  const deleteSuccess = useSelector(selectDelSuccessState);

  // پیام با Toast
  const message = (msg, type) => {
    if (type === 'warn') {
      toast.warning(msg, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(msg, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // وقتی حذف موفق شد، پیام بده و state رو ریست کن
  useEffect(() => {
    if (deleteSuccess) {
      message('خودروی مورد نظر با موفقیت حذف گردید.', 'success');
      dispatch(resetDeleteState());
    }
  }, [deleteSuccess, dispatch]);

  const carDeleteHandler = () => {
    dispatch(deleteCar(car.id));
    closeButtomSheetHandler();
  };

  const handleClose = () => {
    closeButtomSheetHandler();
  };

  return (
    <div className="container">
      <span>آیا از حذف خودروی <strong>{car.title}</strong> اطمینان دارید؟</span>
      <br /><br />
      <div className="container px-4">
        <div className="row gx-5">
          <div className="col">
            <div className="p-1">
              <div className="row row-cols-1">
                <button onClick={carDeleteHandler} className="btn btn-outline-success" type="button">
                  بلی
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="p-1">
              <div className="row row-cols-1">
                <button onClick={handleClose} className="btn btn-outline-danger" type="button">
                  خیر
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteCar;
